import { mdiCheckCircle, mdiInformation } from '@mdi/js';
import Icon from '@mdi/react';

import * as styles from '@/styles/components/Alert';

export type Alert = {
  status: 'success' | 'warning' | 'error';
  title?: string;
  message: React.ReactNode;
};

const Alert = ({ status, title, message }: Alert) => {
  const icon = status === 'success' ? mdiCheckCircle : mdiInformation;

  return (
    <div css={styles.root} data-status={status}>
      <div css={styles.icon} data-status={status}>
        <Icon path={icon} title={status} size='2.2rem' />
      </div>
      <div css={styles.content}>
        {title && (
          <p css={styles.title} role='heading' aria-level={2}>
            <em>{title}</em>
          </p>
        )}
        <p css={styles.message} role='note'>
          {message}
        </p>
      </div>
    </div>
  );
};

export default Alert;
